<template>
  <ol class="breadcrumb">
    <li>
      <div class="row">
        <div class="col-lg-12">
          <span class="active upperbreadcrumb">{{ showName(lastRouteMatch) }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div
            class="active"
            v-for="(filter, index) in filterDisplay"
            :key="index"
          >
            {{ filter }}
          </div>
        </div>
      </div>
    </li>
  </ol>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'

import { useHeaderStore } from '@/stores/header'

import { formatCountryFilters } from "@/components/CountryFilter"

const route = useRoute()

const headerStore = useHeaderStore()
const { filterDataGetter: filters } = storeToRefs(headerStore)

function showName (item: Record<string, any> = {}) {
  /*
    Extracts a human readable version of the route.match to display
  */
  let name
  if (item.meta && item.meta.label) name = item.meta.label
  if (item.name) name = item.name
  if (filters.value.node && headerDisplayed('hierarchy')) {
    name += " / " + filters.value.node.label;
  }
  if (filters.value.childNode && headerDisplayed('hierarchy')) {
    name += " / " + filters.value.childNode.label;
  }
  return name
}

function formatDate (str) {
  /*
    Formats date str to DD-MM-YYYY
  */
  const date = new Date(str)
  const mnth = ("0" + (date.getMonth() + 1)).slice(-2)
  const day = ("0" + date.getDate()).slice(-2);
  return [ day, mnth, date.getFullYear() ].join('-');
}

function headerDisplayed (name) {
  const { header = {} } = route.meta as Record<string, any>
  const { hide = [] } = header as Record<string, any>
  if (hide === true) return false
  return hide.indexOf(name) === -1
}

const lastRouteMatch = computed(() => {
  const matches = route.matched
  return matches[matches.length - 1]
})

const filterDisplay = computed(() => {
  /*
    Shows what filters are currently applied on the page
  */

  // destructure variables needed from state
  const {country, dateRange} = filters.value

  const parts = [];

  // Adds report dates to the breadcrumb
  if (dateRange.value && dateRange.value.length && headerDisplayed('datepicker')) {
    parts.push(
      `Report Dates: ${dateRange.value.map(formatDate).join(' to ')}`
    )
  }

  // Adds countries to the breadcrumb
  if (country && country.length > 0 && headerDisplayed('location')) {
    parts.push(`Locations: ${formatCountryFilters(country)}`)
  }

  return parts
})

defineExpose({ filters })
</script>
